import React from 'react';
import { Icon } from './Icon.js';
export const IconBookmarkSlash = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 3H4V20.8828", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 2L3 22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 23.1172L19.5537 22.3945L10.6709 17.9561L12.0586 16.4131L19 19.8818V8.70215L21 6.47949V23.1172Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconBookmarkSlash.js.map